/* Pawro — policy page engine (theme asset, loaded deferred by
   sections/pawro-policy.liquid).

   Scroll-spy for the sticky contents nav. Deliberately geometry-based
   rather than "whichever IntersectionObserver entry fired last":
   - the theme scrolls an inner wrapper (html/body are overflow:hidden),
     so window.scrollY is useless here — viewport-relative rects are not,
     and a capture-phase scroll listener catches scrolling from ANY
     element, whether the theme scrolls the window or a wrapper;
   - picking the last heading that has crossed a reading line is
     deterministic, so a jump across several sections can't leave the
     wrong item highlighted. */
(function () {
  if (window.__pawroPolicy) return;
  window.__pawroPolicy = true;

  function init() {
    var root = document.querySelector('[data-policy]');
    if (!root) return;

    var sections = Array.prototype.slice.call(root.querySelectorAll('[data-policy-section]'));
    var links = Array.prototype.slice.call(root.querySelectorAll('[data-policy-nav]'));
    if (!sections.length || !links.length) return;

    var rail = root.querySelector('[data-policy-rail]');
    var current = null;

    function centreRail(link) {
      if (!rail || rail.scrollWidth <= rail.clientWidth) return;
      var r = link.getBoundingClientRect();
      var rr = rail.getBoundingClientRect();
      if (r.left < rr.left || r.right > rr.right) {
        rail.scrollTo({
          left: link.offsetLeft - rail.clientWidth / 2 + link.clientWidth / 2,
          behavior: 'smooth'
        });
      }
    }

    function setActive(id) {
      if (id === current) return;
      current = id;
      links.forEach(function (link) {
        var active = link.getAttribute('data-policy-nav') === id;
        link.classList.toggle('is-active', active);
        if (active) {
          link.setAttribute('aria-current', 'true');
          centreRail(link);
        } else {
          link.removeAttribute('aria-current');
        }
      });
    }

    function pick() {
      /* the last section whose heading has passed the reading line wins */
      var line = window.innerHeight * 0.3;
      var best = sections[0];
      for (var i = 0; i < sections.length; i++) {
        if (sections[i].getBoundingClientRect().top - 1 <= line) best = sections[i];
      }
      setActive(best.id);
    }

    var ticking = false;
    function queue() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        pick();
      });
    }

    /* Contents links scroll the section into view themselves. The href is
       kept so the page still works without JS, but native fragment jumps
       don't move this theme (html/body are overflow:hidden and an inner
       wrapper does the scrolling), so we drive it and keep the URL
       shareable via replaceState instead of a second jump. */
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* the element that actually scrolls (this theme scrolls an inner
       wrapper; other themes scroll the window) */
    function scrollPortOf(el) {
      var node = el.parentElement;
      while (node && node !== document.body && node !== document.documentElement) {
        var cs = window.getComputedStyle(node);
        if (/(auto|scroll)/.test(cs.overflowY) && node.scrollHeight > node.clientHeight + 1) return node;
        node = node.parentElement;
      }
      return null;
    }

    /* Scroll the real scrollport directly.

       Deliberately native (compositor-driven) rather than a rAF loop:
       requestAnimationFrame is paused whenever the page isn't visible,
       which makes a hand-rolled animation land intermittently. We compute
       the destination ourselves so scroll-margin-top is honoured, and let
       the browser animate it. */
    function smoothTo(target) {
      var port = scrollPortOf(target);
      var margin = parseInt(window.getComputedStyle(target).scrollMarginTop, 10) || 0;
      var startY = port ? port.scrollTop : (window.pageYOffset || 0);
      var delta = target.getBoundingClientRect().top - (port ? port.getBoundingClientRect().top : 0) - margin;
      var endY = startY + delta;
      var max = port ? port.scrollHeight - port.clientHeight : document.documentElement.scrollHeight - window.innerHeight;
      endY = Math.max(0, Math.min(endY, max));

      /* 'instant' (not 'auto') for reduced motion: 'auto' defers to the
         theme's CSS scroll-behavior, which is smooth — so reduced-motion
         users would still get an animation. */
      var options = { top: endY, behavior: reduced ? 'instant' : 'smooth' };
      if (port) port.scrollTo(options);
      else window.scrollTo(options);
    }
    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        var id = link.getAttribute('data-policy-nav');
        var target = document.getElementById(id);
        if (!target) return;
        event.preventDefault();
        setActive(id);
        if (window.history && window.history.replaceState) {
          window.history.replaceState(null, '', '#' + id);
        }
        /* Move focus for keyboard and screen-reader users FIRST: calling
           focus() (or replaceState) after starting a smooth scroll cancels
           the animation mid-flight, so the scroll must be the last thing
           we do here. */
        target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
        smoothTo(target);
      });
    });

    /* capture phase: catches scroll from the window OR any inner wrapper */
    document.addEventListener('scroll', queue, true);
    window.addEventListener('resize', queue, { passive: true });
    pick();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
